import { render, staticRenderFns } from "./departmentTree.vue?vue&type=template&id=29affb8c&scoped=true&"
import script from "./departmentTree.vue?vue&type=script&lang=js&"
export * from "./departmentTree.vue?vue&type=script&lang=js&"
import style0 from "./departmentTree.vue?vue&type=style&index=0&id=29affb8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29affb8c",
  null
  
)

export default component.exports